var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditPencil = function SvgEditPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "inheirt",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inheirt",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    clipPath: "url(#edit-pencil_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.333 2.667H2.666A1.333 1.333 0 0 0 1.333 4v9.333a1.333 1.333 0 0 0 1.333 1.334H12a1.333 1.333 0 0 0 1.333-1.334V8.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.333 1.667a1.414 1.414 0 1 1 2 2L8 10l-2.667.667L6 8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edit-pencil_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgEditPencil;